import sanityClient from '@sanity/client';

export default sanityClient({
    projectId: "pcqnkk9r",
    dataset: "production"
})